import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class LoginComponent extends Component {

  get COMPONENTNAME() {
      return 'LoginComponent';
  }

  get SELECTORS() {
    return {
      submitBtn: '.login-form #loginBtn'
    };
  }

  constructor(elem) {
    super(elem);
    this.trackingComponent = new TrackingComponent();
  }

  readDOM() {
    return {
      submitBtnArr: document.querySelectorAll(this.SELECTORS.submitBtn),
    }
  }

  bindEvents() {
    const ctx = this;
    if(this.dom.submitBtnArr) {
      this.dom.submitBtnArr.forEach(submitBtn => {
        submitBtn.addEventListener('click', () => {
          let loginType = submitBtn.dataset.loginType;
          let params = { loginType : loginType };
          ctx.trackingComponent.actions.login(params);
        });
      })
    }
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
